'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import useCurrencies from '@framework/ui/Organisms/EnhancedTagging/EnhancedTaggingContext/useCurrencies';
import { usePortfoliosContext } from '@/creditflowresearch/application/PortfolioMonitor/PortfoliosContext';

export const usePortfolioMonitor = () => {
  const { portfolioCollection } = usePortfoliosContext();

  const [isFormOpened, setIsFormOpened] = useState<boolean>(false);

  useEffect(() => {
    setIsFormOpened(false);
  }, [portfolioCollection]);

  return {
    isFormOpened,
    setIsFormOpened,
  };
};

type PortfolioMonitorContextType = ReturnType<typeof usePortfolioMonitor>;

interface IPortfolioMonitorContext extends PortfolioMonitorContextType {
  currencies: ReturnType<typeof useCurrencies>,
}

export const PortfolioMonitorContext = createContext<IPortfolioMonitorContext>(null);

export const usePortfolioMonitorContext = () => {
  const context = useContext(PortfolioMonitorContext);
  if (!context) {
    throw new Error('usePortfolioMonitorContext must be used within the PortfolioMonitorContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const PortfolioMonitorContextProvider = ({ children }: IProps) => (
  <PortfolioMonitorContext.Provider value={ {
      ...usePortfolioMonitor(),
      currencies: useCurrencies(),
    } }
  >
    { children }
  </PortfolioMonitorContext.Provider>
);

export default PortfolioMonitorContextProvider;
